__turbopack_context__.v({
  "className": "roboto_slab_3c5f9c09-module__Y5FejG__className",
});
